import { EditableSelect } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableSelect = styled(EditableSelect)`
  width: 100%;
  position: relative;
  z-index: 1;

  .ant-select {
    width: 100% !important;
  }

  .ant-select-selector {
    width: 100% !important;
  }
`;
